import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { useEffect, useState } from 'react';

export const useUtmParams = () => {
    const [utmParams, setUtmParams] = useState<ParsedUrlQuery | null>(null);
    const router = useRouter();

    useEffect(() => {
        if (!router.isReady) return;

        const query: ParsedUrlQuery = router.query;

        // Фильтруем только UTM-параметры
        const utmOnlyParams: ParsedUrlQuery = Object.fromEntries(
            Object.entries(query).filter(
                ([key, value]) => key.startsWith('utm_') && value !== undefined && value !== null,
            ),
        );

        // Проверяем, есть ли хотя бы один UTM-параметр
        const hasUtmParams = Object.keys(utmOnlyParams).length > 0;

        if (hasUtmParams) {
            localStorage.setItem('utmParams', JSON.stringify(utmOnlyParams));
            setUtmParams(utmOnlyParams);
        } else {
            setUtmParams(null);
        }
    }, [router.isReady, router.query]);

    return utmParams;
};
